export default __webpack_public_path__ + "static/media/step-2.00e1b211.jpeg";